import { Injectable } from '@angular/core';
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class RefreshTokenStorageService {

  storageKey = "refresh_token";

  constructor() { }

  storeRefreshToken(refreshToken) {
    localStorage.setItem(this.storageKey, refreshToken);
  }

  loadRefreshToken() {
    return localStorage.getItem(this.storageKey);
  }

  clear() {
    return localStorage.removeItem(this.storageKey);
  }
}
